/*
 * Mensagem única para toda falha de login social.
 *
 * O backend responde a mesma mensagem genérica em todos os motivos de recusa
 * para não revelar se um e-mail tem conta na plataforma. O front mantém um só
 * texto pela mesma razão — mensagens diferentes por provedor reintroduziriam a
 * diferença que o backend faz questão de esconder.
 */
export const SOCIAL_AUTH_ERROR_MESSAGE =
  'Não foi possível fazer login. Tente novamente.';

export const SOCIAL_AUTH_ERROR_TITLE = 'Não foi possível entrar';

/*
 * Provedores sociais suportados, na ordem em que aparecem na tela de login.
 *
 * Também é o que o interceptador do axios usa para reconhecer uma resposta de
 * login social: ali o 401 é a recusa do próprio login, não sessão expirada.
 */
export const SOCIAL_AUTH_PROVIDER_IDS = ['google', 'apple'] as const;

export type SocialProviderId = (typeof SOCIAL_AUTH_PROVIDER_IDS)[number];
